import React from 'react';
import { Stack } from 'expo-router';
import { observer } from '@legendapp/state/react';
import { View, StyleSheet } from 'react-native';
import { getLogger } from '../../utils/logger';
import theme from '../../config/theme';

// Logger específico para este componente
const logger = getLogger('APP-(AUTH)-LAYOUT');

const AuthLayout = observer(() => {
  logger.debug('Renderizando AuthLayout');
  
  return (
    <View style={styles.container}>
      <Stack 
        initialRouteName="login"
        screenOptions={{
          headerShown: false,
          contentStyle: {
            backgroundColor: theme.colors.background.primary,
          },
        }}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background.primary,
  },
});

export default AuthLayout; 